module.exports = __webpack_public_path__ + "img/medal-badge.a554cbb.svg";